import { render } from "./staffaccountinglist.vue?vue&type=template&id=4e571214"
import script from "./staffaccountinglist.vue?vue&type=script&lang=js"
export * from "./staffaccountinglist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__